import { FC } from "react";
import { Bar, BarChart, CartesianGrid, LabelList, XAxis } from "recharts";
import { ChartConfig, ChartContainer } from "~/components/ui/chart";

const chartConfig = {
  desktop: {
    label: "Pages",
    color: "hsl(var(--chart-1))",
  },
} satisfies ChartConfig;

interface SettingsChartProps {
  data: Array<object>;
}

const CustomLabel = (props: any) => {
  const { x, y, width, value } = props;
  if (value === 0) return null;
  return (
    <text
      x={x + width / 2}
      y={y - 10}
      fill="text-base-foreground"
      textAnchor="middle"
      dominantBaseline="middle"
    >
      {value}
    </text>
  );
};

export const SettingsChart: FC<SettingsChartProps> = ({ data }) => {
  return (
    <ChartContainer
      config={chartConfig}
      className="h-[320px] w-full min-w-0 min-h-[200px]"
    >
      <BarChart accessibilityLayer data={data} margin={{ top: 20 }}>
        <CartesianGrid vertical={false} />
        <XAxis dataKey="date" tickLine={false} axisLine={false} />
        <Bar dataKey="pages" fill="hsl(var(--chart-2))" radius={8}>
          <LabelList dataKey="pages" content={CustomLabel} />
        </Bar>
      </BarChart>
    </ChartContainer>
  );
};
